import jwt_decode from "jwt-decode";

export function getLoggedInUserEmail() :string {
    interface DecodedToken {
        email: string
    }
    const decodedToken: DecodedToken = jwt_decode(localStorage.getItem('access_token') as string);
    const user: string = decodedToken.email
    return user.trim()
}